import { AlertTriangle } from "lucide-react";
import { useRouteError } from "react-router";

/**
 * Fallback amigável para erros de renderização/loader de uma rota (RB-044).
 *
 * Evita a tela branca "Unexpected Application Error!" do React Router quando um
 * dado inesperado quebra o componente da rota. Como é anexado no `errorElement`
 * da rota-filha, o shell do app (menu lateral/topo) continua renderizado — só a
 * área de conteúdo é substituída por esta mensagem.
 */
export function RouteErrorBoundary() {
  const error = useRouteError();
  const detalhe =
    error instanceof Error ? error.message : "Ocorreu um erro inesperado.";

  return (
    <div className="flex flex-col items-center justify-center gap-4 rounded-lg border border-gray-200 bg-white p-10 text-center">
      <AlertTriangle className="text-yellow-500" size={40} />
      <div>
        <h2 className="text-lg font-semibold text-gray-800">
          Não foi possível exibir esta tela
        </h2>
        <p className="mt-1 text-sm text-gray-500">
          Ocorreu um erro ao carregar o conteúdo. Tente recarregar; se o problema
          persistir, contate o suporte.
        </p>
      </div>
      <button
        onClick={() => window.location.reload()}
        className="rounded-md bg-[#034065] px-4 py-2 text-sm font-medium text-white transition-opacity hover:opacity-90"
      >
        Recarregar
      </button>
      {import.meta.env.DEV && (
        <pre className="mt-2 max-w-full overflow-auto rounded bg-gray-50 p-2 text-left text-[11px] text-gray-400">
          {detalhe}
        </pre>
      )}
    </div>
  );
}
